const OpenAI = require("openai-api");
// const OAK = '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';
const OAK = "sk-proj-3zmLnrxu2YsfGFP2WD6DT3BlbkFJKjNEOhdrWJHsk9969TRC";
const openai = new OpenAI(OAK);

const TextGenerator = (
  language,
  type,
  currentValue,
  amenities,
  address,
  audience,
  keywords,
  accommodationType,
  enhancements
) => {
  let chars = type == "description" ? 1500 : 100;
  let promptIntro =
    currentValue != ""
      ? `Improve this ${type}: '${currentValue}'`
      : `Write a human friendly ${type}`;
  let prompt = `${promptIntro} for a ${accommodationType} for rent located at ${address}, but don't mention the address. If there are highlights in the area, write about the area too. `;
  if (keywords != null && keywords !== "") {
    prompt += `If it makes for a better ${type}, include these keywords: ${keywords}. `;
  }
  if (amenities.length > 0) {
    prompt += `Maybe include some of the following amenities in the ${type}, but only if they are relevant: ${amenities}. `;
  }
  // const completions = await openai.complete({
  // return openai.complete({
  //   engine: 'text-davinci-003',
  //   prompt,
  //   maxTokens: 3500,
  //   n: 1,
  // }).then(completions => {
  //   const description = completions.data.choices[0].text.trim();
  //   return description;
  // });
  let rules = `Do not use superlatives in the ${type}. Do not enclose the output in quotation marks. The ${type} must be written in the following language: ${language}. Maximum response length of ${chars} characters. Avoid sounding like AI-generated text. `;
  if (audience != null && audience !== "") {
    rules += `Context for the ${type}: ${audience}. `;
  }
  if (enhancements != null && enhancements !== "") {
    rules += `${enhancements}`;
  }
  return openai
    .chat({
      model: "gpt-4o-mini",
      messages: [
        { role: "system", content: rules }, // apply enhancements here
        { role: "assistant", content: prompt },
      ],
      maxTokens: 3500,
      n: 1,
    })
    .then((chatResponse) => {
      const description = chatResponse.data.choices[0].message.content.trim();
      if (type != "description") {
        return description.replace(/\.+$/, "");
      }
      return description;
    });
  // const description = completions.choices[0].text.trim();
  // return description;
};

export default TextGenerator;
